module.exports = __webpack_public_path__ + "img/game_pp.c0763448.png";